/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : VehicleSavedLinkageCard.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import { Box, Typography, IconButton } from "@mui/material";
import React, { useEffect, useState } from "react";
import { componentStyle } from "../../../config/appTheme";
import CloseIcon from "@mui/icons-material/Close";

function VehicleSavedLinkageCard({
  savedLinkages,
  setSavedLinkages,
  entityType,
  onRemove,
}) {
  const getKeyBasedOnEntity = () => {
    switch (entityType) {
      case "ee":
        return {
          idKey: "ee_id",
          displayKey: "Assembly Number ",
          displayValue: (item) => item?.addOn?.assembly_number,
        };
      case "swm":
        return {
          idKey: "swm_id",
          displayKey: "Number ",
          displayValue: (item) => item?.addOn?.name,
        };
      case "vs":
        return {
          idKey: "vs_id",
          displayKey: "Name",
          displayValue: (item) => {
            return item?.addOn?.name;
          },
        };
      default:
        return {
          idKey: "ee_id",
          displayKey: "Assembly Number ",
          displayValue: (item) => item?.addOn?.assembly_number,
        };
    }
  };

  const [modifiedLinkItems, setModifiedLinkItems] = useState([]);
  const entityConfig = getKeyBasedOnEntity();

  useEffect(() => {
    let array = savedLinkages;
    setModifiedLinkItems(array);
  }, [savedLinkages]);
  return (
    <Box>
      {modifiedLinkItems?.map((item, index) => {
        return (
          <Box
            key={index}
            sx={{
              mb: 2,
              ...componentStyle.font.text,
              color: "white",
              backgroundColor: "black",
              display: "flex",
              gap: 2,
              p: 1,
            }}
          >
            <IconButton
              onClick={() => {
                const updatedLinkages = savedLinkages.filter(
                  (linkage) =>
                    linkage[entityConfig.idKey] !== item[entityConfig.idKey]
                );
                setSavedLinkages(updatedLinkages);
                onRemove?.();
              }}
              sx={{ color: "white", ml: 1, mr: 1, mt: -1 }}
            >
              <CloseIcon />
            </IconButton>
            <Typography>{`Name: ${item?.vs_name || "-"}`}</Typography>
            <Typography>{`Description: ${item?.description}`}</Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default VehicleSavedLinkageCard;

const styles = {
  tabsContainer: {
    borderBottom: 1,
    borderColor: "divider",
  },
  tabsContainerCentered: {
    display: "flex",
    justifyContent: "center",
  },
  tabs: {
    "& .MuiTab-root": {
      color: "#000000ff",
      textTransform: "none",
    },
    "& .Mui-selected": {
      color: "#000000ff !important",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "#4caf50",
    },
  },
  tabLabelContainer: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  countBadge: {
    backgroundColor: "#D0D0CE",
    color: "black",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "12px",
    fontWeight: "bold",
    padding: "5px",
  },
  panelBox: {
    p: 3,
  },
};
